<template>
    <div>
        
        <ImplantsPain />
    </div>
</template>

<script>

import ImplantsPain from '../blog-details/ImplantsPain.vue'

export default {
    components: {
    
        ImplantsPain,
    }
}
</script>